<template>
  <div v-if="campaingInfo">
    <div class="banner"></div>
    <p class="date">
      開催期間:20{{toDate(campaingInfo.startTime)}}-20{{toDate(campaingInfo.endTime)}}<br>
      ※本キャンペーンは予告なく終了する場合がございます。
    </p>
    <!-- 受取期間表示 -->
    <template v-if="campaingInfo.receiveTerm">

      <p class="date">キャンペーンは終了しました</p>
      <p class="date">受取期限:20{{toDate(campaingInfo.recievEndTime)}}まで</p>

      <!-- 受け取れる場合のみ表示 -->
      <template v-if="campaingInfo.stepId !== campaingInfo.maxStepId && nowStampCount === 10">
        <section-header heading="2" ja="キャンペーンポイント"/>
        <div class="stampCardCount"><span>{{ campaingInfo.stepId === campaingInfo.maxStepId ? campaingInfo.maxStepId : campaingInfo.stepId + 1 }}枚目</span></div>
        <div class="stampCard">
          <div class="stamp" v-for="i in 10" :key="i" :class="{get: i <= nowStampCount}"><span>{{i}}</span></div>
          <div class="complete" v-if="campaingInfo.stepId === campaingInfo.maxStepId"></div>
        </div>
        <div class="message" v-if="campaingInfo.stepId === campaingInfo.maxStepId">
          <p>全てのクーポンを受け取りました！</p>
          <p>キャンペーンへのご参加ありがとうございます！</p>
        </div>
        <normal-btn @click="getCoupon()" v-if="campaingInfo.stepId !== campaingInfo.maxStepId" :disabled="nowStampCount < 10">{{nowStampCount === 10 ? '' : `あと${10 - nowStampCount}Pで「fiz」`}}クーポンGET!!</normal-btn>
      </template>

    </template>

    <!-- 開催表示 -->
    <template v-else>

      <normal-btn @click="openDescDialog=true">キャンペーンの遊び方</normal-btn>
      <section-header heading="2" ja="キャンペーンポイント"/>
      <div class="stampCardCount"><span>{{ campaingInfo.stepId === campaingInfo.maxStepId ? campaingInfo.maxStepId : campaingInfo.stepId + 1 }}枚目</span></div>
      <div class="stampCard">
        <div class="stamp" v-for="i in 10" :key="i" :class="{get: i <= nowStampCount}"><span>{{i}}</span></div>
        <div class="complete" v-if="campaingInfo.stepId === campaingInfo.maxStepId"></div>
      </div>
      <div class="message" v-if="campaingInfo.stepId === campaingInfo.maxStepId">
        <p>全てのクーポンを受け取りました！</p>
        <p>キャンペーンへのご参加ありがとうございます！</p>
      </div>
      <normal-btn @click="getCoupon()" v-if="campaingInfo.stepId !== campaingInfo.maxStepId" :disabled="nowStampCount < 10">{{nowStampCount === 10 ? '' : `あと${10 - nowStampCount}Pで「fiz」`}}クーポンGET!!</normal-btn>

      <template v-if="nowStampCount < 10">
        <div class="message">
          <p>10P貯めるには</p>
          <p><span class="lightblue">はじめて撮影する友達</span>と、あと<span class="lightblue">1回</span>プレイ</p>
          <p>OR</p>
          <p><span class="pink">いままで撮影したことあのある友達</span>と、あと<span class="pink">{{Math.ceil((10 - nowStampCount) / 4)}}回</span>プレイ</p>
        </div>
      </template>
      <div class="infoLink">
        <div class="link-text" @click="onFriendCampaignHistory">いままで撮影したことのある友達</div>
      </div>
      <Dialog v-if="openDescDialog">
        <div class="dialogTitle">キャンペーンの遊び方</div>
        <div class="dialogDescription">
          ■遊び方<br>
          1.友達と一緒にQR会員証を使って『fiz』『fiz2』をプレイ<br>
          ※必ず一緒に会員証を使ってね！<br>
          <br>
          2.ポイントが貯まったら、<br>
          『fiz』『fiz2』￥200 OFFクーポンをプレゼント！<br>
          ※このページで受け取りボタンを押してね！<br>
          <br>
          ■ポイント・クーポン<br>
          ☆もらえるポイント<br>
          ・期間中に初めて一緒に撮った場合：10P<br>
          ・期間中に既に一緒に撮ったことがある場合：4P<br>
          <br>
          ☆もらえるクーポン<br>
          ・10/20/30/40/50P：『fiz』『fiz2』￥200 OFFクーポン<br>
          ・50P：『プリもっと』無料クーポン<br>
          <br>
          ■注意事項<br>
          ・会員証を一緒に使って撮影しないと<br> ポイントは獲得できません<br>
          ・3人以上で一緒にプレイした場合、<br> 一番高い組み合わせのポイントがもらえます<br>
          ・クーポンの使用期限はキャンペーンのお知らせか<br> 受け取ったクーポンから確認できます
        </div>
        <button class="closeBtn" @click="openDescDialog=false" />
      </Dialog>

    </template>

    <Dialog v-if="openGetDialog">
      <div class="dialogTitle">クーポンGET！</div>
      <div class="dialogDescription">
        <coupon
            class="coupon"
            :image-path="getCouponInfo.imagePath"
            :advertise = "getCouponInfo.advertise"
            :start-time="getCouponInfo.startTime"
            :end-time="getCouponInfo.endTime"
            :use-num="getCouponInfo.useNum"
            :description="getCouponInfo.description"
            :kind="getCouponInfo.kind"
          ></coupon>
      </div>
      <p class="message">クーポンページから確認してね！</p>
      <button class="closeBtn" @click="openGetDialog=false, getCouponInfo=null" />
    </Dialog>

    <Dialog v-if="openCompGetDialog">
      <div class="dialogTitle">クーポンGET！</div>
      <div class="dialogDescription">
        <coupon
            class="coupon"
            :image-path="getCompCouponInfo.imagePath"
            :advertise = "getCompCouponInfo.advertise"
            :start-time="getCompCouponInfo.startTime"
            :end-time="getCompCouponInfo.endTime"
            :use-num="getCompCouponInfo.useNum"
            :description="getCompCouponInfo.description"
            :kind="getCompCouponInfo.kind"
          ></coupon>
      </div>
      <p class="message">クーポンページから確認してね！</p>
      <button class="closeBtn" @click="openCompGetDialog=false, getCompCouponInfo=null" />
    </Dialog>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import Dialog from '@/components/Dialog'
import Coupon from "../components/Coupon"
import { ymd } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "FriendCampaign",
  mixins: [Protobuf],
  components: {
    SectionHeader,
    NormalBtn,
    Dialog,
    Coupon,
  },
  data() {
    return {
      campaingInfo: null, // キャンペーン情報
      getCouponInfo: null, // 取得したクーポン情報
      getCompCouponInfo: null, // コンプリートで取得したクーポン情報
      openDescDialog: false, // 説明ダイアログ開くフラグ
      openGetDialog: false, // 取得したクーポン表示するダイアログ開くフラグ
      openCompGetDialog: false, // コンプリートで取得したクーポン表示するダイアログ開くフラグ
    }
  },
  computed: {
    nowStampCount() {
      if (this.campaingInfo.stepId === this.campaingInfo.maxStepId) return 10
      return (this.campaingInfo.point - this.campaingInfo.stepId * 10) > 10 ? 10 : (this.campaingInfo.point - this.campaingInfo.stepId * 10)
    }
  },
  mounted() {
    // キャンペーン情報取得
    this.getCampaignInfo()
  },
  methods: {
    /**
     * キャンペーン情報取得
     */
    getCampaignInfo() {
      const cmdNo = pb.CampaignFriendPointReq.CommandNo.COMMAND_NO
      const message = pb.CampaignFriendPointReq.create()
      const encoded = pb.CampaignFriendPointReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded === undefined) {
            this.$_error('Error', { title: '一緒にプリクラ！キャンペーン', statusCode: 100 })
            return
          }
          // 0なら開催中
          if (decoded.status !== 0) {
            this.$router.push('/')
            return
          }
          this.campaingInfo = decoded
        })
        .catch(() => {
          this.$_error('Error', { title: '一緒にプリクラ！キャンペーン', statusCode: 100 })
        })
    },

    /**
     * クーポン受取
     */
    getCoupon() {
      const cmdNo = pb.CampaignFriendItemGetReq.CommandNo.COMMAND_NO
      const message = pb.CampaignFriendItemGetReq.create({
        stepId: this.campaingInfo.stepId + 1, // 次のステップのクーポンを受け取るので+1
      })
      const encoded = pb.CampaignFriendItemGetReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.getCampaignInfo()
          this.getCouponInfo = decoded.stepBoarderInfo
          this.openGetDialog = true
          if (decoded.completeBoarderInfo) {
            this.getCompCouponInfo = decoded.completeBoarderInfo
            this.openCompGetDialog = true
          }
        })
        .catch(() => {
          this.$_error('Error', { title: '一緒にプリクラ！キャンペーン', statusCode: 100 })
        })
    },

    /**
     * 日付表示
     */
    toDate(intTime) {
      return ymd(intTime).join('.')
    },

    /**
     * フレンドキャンペーン履歴へ遷移
     */
    onFriendCampaignHistory() {
      this.$router.push('/friendCampaignHistory')
    },
  }
}
</script>

<style lang="scss" scoped>
.banner {
  height: 144px;
  width: 100%;
  background-image: url(../assets/Png/friend_campaign/friend_campaign_banner.png);
  background-size: contain;
  background-color: #95D7F6;
}
.date {
  margin: 20px 30px;
  font-size: 12px;
  color: #373737;
}
.stampCardCount {
  margin: 20px 30px;
  font-size: 14px;
  color: #F63C5B;
  font-weight: normal;
  & > span {
    background-image: linear-gradient(to bottom, transparent 60%, #F7D0DD 61%);
  }
}
.stampCard {
  position: relative;
  margin: 20px 30px;
  padding: 20px;
  width: 315px;
  height: 144px;
  background-image: url(../assets/Png/friend_campaign/friend_campaign_point_bg.png);
  background-size: contain;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .complete {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,.5);
    background-image: url(../assets/Png/friend_campaign/friend_campaign_complete.png);
    background-size: 70%;
    background-position: center;
  }

  .stamp {
    position: relative;
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color: #FFF;
      z-index: 1;
    }
    &::before {
      content: '';
      position: absolute;
      display: block;
      width: 32px;
      height: 32px;
      background-color: #C7C9CA;
      border-radius: 50%;
    }
    &.get::before { background-color: #DA2240; }
  }
}
.message {
  margin: 20px 30px;
  font-size: 12px;
  color: #373737;
  .lightblue { color: #F63C5B; }
  .pink { color: #EF2562; }
}

.infoLink {
  margin-top: 20px;
  padding: 0 30px;
  cursor: pointer;
  & > div {
    margin-top: 15px;
    padding-right: 30px;
    text-align: right;
    font-size: 10px;
    color: #F63C5B;
    background-image:
      linear-gradient(to left, #F63C5B, #F63C5B),
      linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
    background-repeat: no-repeat;
    background-size: 24px 1px, 8px 8px;
    background-position: right 70%, right 40%;
  }
}

.dialog {
  .dialogTitle {
    text-align: center;
    font-size: 14px;
    color: #F63C5B;
  }
  .dialogDescription {
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
